import {
  SWIPE_REQUEST,
  SWIPE_SUCCESS,
  SWIPE_FAILURE,
  UNDO_SWIPE_REQUEST,
  UNDO_SWIPE_SUCCESS,
  UNDO_SWIPE_FAILURE
} from './swipeActionTypes'

const initialState = {
  loading: false,
  error: null,
  lastSwipe: null
}

export default function swipeReducer(state = initialState, action) {
  switch (action.type) {
    case SWIPE_REQUEST:
      return { ...state, loading: true, error: null }
    case SWIPE_SUCCESS:
      return {
        ...state,
        loading: false,
        lastSwipe: action.payload,
        error: null
      }
    case SWIPE_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case UNDO_SWIPE_REQUEST:
      return { ...state, loading: true, error: null }
    case UNDO_SWIPE_SUCCESS:
      return { ...state, loading: false, lastSwipe: null, error: null }
    case UNDO_SWIPE_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}
